import { render, staticRenderFns } from "./SignProcess.vue?vue&type=template&id=6650a86c&scoped=true&"
import script from "./SignProcess.vue?vue&type=script&lang=js&"
export * from "./SignProcess.vue?vue&type=script&lang=js&"
import style0 from "./SignProcess.vue?vue&type=style&index=0&id=6650a86c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6650a86c",
  null
  
)

export default component.exports